<template>
    <div>
        <account-form
            class="max-w-sm mx-auto pb-10"
            :enable-incomplete-registration="true"/>
        <!-- <trust-pilot-review v-if="hideForCountry" step="account"/> -->
        <div class="clear--sm"></div>
        <supported-cards />
        <div class="clear--sm"></div>
    </div>
</template>

<script>
import AccountForm from '@/components/forms/register/AccountForm';
import SupportedCards from '@/components/forms/fields/SupportedCards';
// import TrustPilotReview from '@/components/forms/fields/TrustPilotReview';

export default {
    name: 'Account',
    components: {
        AccountForm,
        SupportedCards,
        // TrustPilotReview,
    },
};
</script>
